import { render, staticRenderFns } from "./batch-assign-button.vue?vue&type=template&id=f5dec136&scoped=true&"
import script from "./batch-assign-button.vue?vue&type=script&lang=js&"
export * from "./batch-assign-button.vue?vue&type=script&lang=js&"
import style0 from "./batch-assign-button.vue?vue&type=style&index=0&id=f5dec136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dec136",
  null
  
)

export default component.exports